import axios, { AxiosResponse } from "axios";
import toast from "react-hot-toast";
import { baseServiceUrl, urls } from "../environment";

import {
  CreateScrutinyInterface,
  GetScrutinyListInterface,
} from "../interfaces/exams.interface";
import useUserStore from "../stores/useUserStores";

//   import { DomainTypes, DomainTypesMain } from "../interfaces/domain.interface";
//   import { UserContext, useUserContext } from "./UserContext";
//   import axios from "axios";
//   import { baseServiceUrl, urls } from "../environment";
//   import toast from "react-hot-toast";

export type ScrutinyContextProps = {
  getScrutinyListingHandler: ({
    payload,
    successCallback,
    failureCallback,
    finallyCallback,
  }: {
    payload: any;
    successCallback?: (args?: any) => void;
    failureCallback?: (args?: any) => void;
    finallyCallback?: (args?: any) => void;
  }) => Promise<any>;
  ApplyScrutinyHandler: ({
    payload,
    successCallback,
    errorCallback,
    finallyCallback,
  }: {
    payload: any;
    successCallback?: () => void;
    errorCallback?: () => void;
    finallyCallback?: () => void;
  }) => Promise<AxiosResponse<any, any> | undefined>;
  getScrutinyList: ({
    payload,
    successCallback,
    errorCallback,
    finallyCallback,
  }: {
    payload: any;
    successCallback?: () => void;
    errorCallback?: () => void;
    finallyCallback?: () => void;
  }) => Promise<any>;
};

const useScrutinyServices = (): ScrutinyContextProps => {
  const userDetails = useUserStore();

  const ApplyScrutinyHandler = async ({
    payload,
    successCallback,
    errorCallback,
    finallyCallback,
  }: {
    payload: CreateScrutinyInterface;
    successCallback?: () => void;
    errorCallback?: () => void;
    finallyCallback?: () => void;
  }) => {
    try {
      userDetails.setLoading(true);
      const response = await axios.post(
        baseServiceUrl + urls.createScrutiny,
        payload,
        {
          headers: {
            Authorization: "Bearer " + userDetails.token,
          },
        }
      );
      toast.success("Objection Request Submitted");
      successCallback?.();
      return response;
    } catch (error) {
      errorCallback?.();
      toast.error("something went wrong");
    } finally {
      finallyCallback?.();
      userDetails.setLoading(false);
    }
  };

  const getScrutinyListingHandler = async ({
    payload,
    successCallback,
    failureCallback,
    finallyCallback,
  }: {
    payload: any;
    successCallback?: (args?: any) => void;
    failureCallback?: (args?: any) => void;
    finallyCallback?: (args?: any) => void;
  }) => {
    try {
      userDetails.setLoading(true);
      const response = await axios.post(
        baseServiceUrl + urls.scrutinyListing,
        payload,
        {
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
          },
        }
      );
      successCallback?.();
      finallyCallback?.();
      userDetails.setLoading(false);
      return response?.data;
    } catch (error) {
      failureCallback?.();
    } finally {
      finallyCallback?.();

      userDetails.setLoading(false);
    }
  };

  const getScrutinyList = async ({
    payload,
    successCallback,
    errorCallback,
    finallyCallback,
  }: {
    payload: GetScrutinyListInterface;
    successCallback?: () => void;
    errorCallback?: () => void;
    finallyCallback?: () => void;
  }) => {
    try {
      userDetails.setLoading(true);
      const response = await axios.post(
        baseServiceUrl + urls.scrutinyListing,
        payload,
        {
          headers: {
            Authorization: "Bearer " + userDetails.token,
          },
        }
      );
      successCallback?.();
      return response.data;
    } catch (error) {
      errorCallback?.();
      toast.error("something went wrong");
    } finally {
      finallyCallback?.();
      userDetails.setLoading(false);
    }
  };
  return {
    ApplyScrutinyHandler,
    getScrutinyList,
    getScrutinyListingHandler,
  };
};

export default useScrutinyServices;
